import axios from 'axios'
import { constants as C } from './constants'

export const fetchDocuments = () => {
    return axios.get(C.DOCUMENTS_ENDPOINT)
}

export const downloadDocument = (docUrl) => {
    return axios.get(
        C.DOWNLOAD_ENDPOINT,
        {
            params: { url: docUrl },
            responseType: "arraybuffer"
        }
    )
}